module.exports = __webpack_public_path__ + "img/Add_yellowgradient_icon.4bbe7a55.png";